import React from "react";
import "./style.scss";

type Props = {};

const Footer = (props: Props) => {
  return (
    <footer>
      <p>
        Design e implementações feitos por
        <a href="https://twitter.com/lucianoasri">@lucianoasri</a>
      </p>
    </footer>
  );
};

export default Footer;
